
import check from "../../../assets/images/checkulli.svg"
import styles from "./style.module.css";



const StayConnected = () => {
 

  return (
    <>
      <div className={styles.simsection}>
        <div className="container-fluid">
          <div className={`${styles.simsections} `}>
            <div className="col-xl-9 col-12 mx-auto">
              <div className={`${styles.simcontent}`}>
                <h3>Why You Need a eSIM When You Travel</h3>
                <p>Whether you're moving for education or work, staying connected is <br className="d-lg-block d-none"/>vital. A local SIM helps you:</p>

              </div>
              <ul className={`${styles.simfeatures} ps-0 row align-items-center g-lg-4 g-3 mb-0`}>               
                  <li className={styles.feature}>
                    <span><img src={check} alt="" /></span> Access maps, apps, and transit info
                  </li>
                  <li className={styles.feature}>
                    <span><img src={check} alt="" /></span> Receive OTPs & important updates
                  </li>
                  <li className={styles.feature}>
                    <span><img src={check} alt="" /></span> Contact family & services instantly
                  </li>
                  <li className={styles.feature}>
                    <span><img src={check} alt="" /></span> Avoid expensive roaming charges
                  </li>
              </ul>
              <div className="col-12 text-center mt-5">
              <button className={styles.ctabtn}>Claim 1GB Data</button>
              </div>
            </div>
          
          </div>
        </div>
      </div>
    </>
  );
};

export default StayConnected;
